import React from "react";

export const FrameByAnima = (): JSX.Element => {
  const travelKits = [
    {
      title: "Sky Joy™ Kit",
      description:
        "Perfect for air travel, featuring compact activities and secure components designed for tray tables and high altitudes.",
      bgColor: "bg-gradient-to-r from-[#E53E5F] to-[#D82B3C]", // Gradient background for Sky Joy
    },
    {
      title: "Jai Pavan™ Kit",
      description:
        "Specially crafted for train journeys, with extended activities and Indian railway-themed adventures.",
      bgColor: "bg-gradient-to-r from-[#F5A93E] to-[#F1B94A]", // Gradient background for Jai Pavan
    },
  ];

  return (
    <section id="kits" className="pt-16 pb-16">
      <div className="flex flex-col md:flex-row items-stretch gap-6 md:gap-12 p-4 md:p-16">
        {travelKits.map((kit, index) => (
          <div
            key={index}
            className={`border-2 border-transparent ${kit.bgColor} shadow-lg rounded-3xl overflow-hidden flex-1 w-full transition-transform transform hover:scale-105`}
          >
            <div className="gap-4 md:gap-6 p-6 flex flex-col items-start justify-between flex-grow text-white">
              <h3 className="font-['Plus_Jakarta_Sans', Helvetica] font-semibold text-xl md:text-xl tracking-tight leading-snug">
                {kit.title}
              </h3>
              <p className="font-['Plus_Jakarta_Sans', Helvetica] font-medium text-lg md:text-ll tracking-tight leading-relaxed opacity-80">
                {kit.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
